import { render, staticRenderFns } from "./configuracionNotificaciones.vue?vue&type=template&id=690dad1b&"
import script from "./configuracionNotificaciones.vue?vue&type=script&lang=js&"
export * from "./configuracionNotificaciones.vue?vue&type=script&lang=js&"
import style0 from "./configuracionNotificaciones.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports